import React from 'react';
import { useTranslation } from 'react-i18next';

const FullScreenLoader = ({ isLoading }) => {
  const { t } = useTranslation();

  return (
    <div 
      className={`fixed inset-0 z-[9999] bg-white flex flex-col items-center justify-center transition-all duration-700 ease-in-out ${!isLoading ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}
    >
      <div className="relative flex justify-center items-center">
        <div className="absolute inset-0 rounded-full border-4 border-slate-100 h-24 w-24"></div>
        <div className="animate-spin rounded-full border-4 border-t-[#0078d4] border-r-transparent border-b-transparent border-l-transparent h-24 w-24 z-10"></div>
        <span className="absolute text-xl">⚓</span>
      </div>
      <h2 className="mt-8 text-[#0078d4] font-bold text-xl tracking-wider">Bizerte Connect</h2>
      <p className="text-slate-500 text-sm mt-2">{t('common.loading', { defaultValue: 'Loading...' })}</p>
    </div>
  );
};

export default FullScreenLoader;
